import { Guarantee } from '@/types/index'
import s from './guaranteeCard.module.scss'

const GuaranteeCard = ({ guarantee }: { guarantee: Guarantee }) => (
  <div className={s.option}>
    <div className={s.option_titles}>
      <img src={guarantee.icon} alt={guarantee.title} />
      <h2 className={s.option_title}> {guarantee.title} </h2>
      <p className={s.option_included}> Free, Included </p>
      <p className={s.option_sub}>{guarantee.subtitle}</p>
    </div>
    <div className={s.option_wrapper}>
      <h3 className={s.option_subtitle}>{guarantee.coverPeriod.title}</h3>
      <p className={s.option_description}>
        {guarantee.coverPeriod.description}
      </p>
    </div>
    <div>
      <h3 className={s.option_subtitle}>{guarantee.covered.title}</h3>
      <p className={s.option_description}>{guarantee.covered.description}</p>
    </div>
    {guarantee.covered.note && (
      <div className={s.option_note}>
        <p className={s.option_note_description}>
          Note: {guarantee.covered.note}
        </p>
      </div>
    )}
  </div>
)

export default GuaranteeCard
